import { Modal, Table } from 'antd';
import dayjs from 'dayjs';

import ExpandedRow from './expanded-row';

const columns = [
  {
    title: 'Tarih',
    dataIndex: 'date',
    render: (text) => dayjs(text).format('DD.MM.YYYY HH:mm'),
  },
  {
    title: 'Kullanıcı',
    dataIndex: 'user',
  },
  {
    title: 'Birim',
    dataIndex: 'unit',
  },
  {
    title: 'İşlem',
    dataIndex: 'decision',
    render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />,
  },
];

const HistoryModal = ({ open, onClose, dataSource, isFetching }) => (
  <Modal
    open={open}
    title="Geçmiş Hareketler"
    width="80%"
    footer={null}
    onCancel={onClose}
    destroyOnClose
  >
    <Table
      bordered
      pagination={false}
      loading={isFetching}
      rowKey={(record) => record.id}
      dataSource={dataSource}
      scroll={{ y: 750 }}
      columns={columns}
      expandable={{
        expandedRowRender: (record) => <ExpandedRow record={record} />,
        rowExpandable: (record) =>
          record.authorContent?.contents?.length > 0 ||
          record.revertReasons?.length > 0 ||
          record.authorContent?.authorDescription ||
          record.authorContent?.mediaOfferDescription ||
          record.lastOpinion,
      }}
    />
  </Modal>
);

export default HistoryModal;
